module.exports = __webpack_public_path__ + "static/media/icon-warning.3814896e.svg";